
import user from './interface/user'
import common from './interface/common'
export default Object.assign(
  user,
  common
)



// WEBPACK FOOTER //
// ./src/api/index.js